import React, { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { PageTemplate } from '../pageTemplates';
import * as S from './styles';

const msgs = defineMessages({
  memrise: { id: 'memrise_logo_link_alt_text' },
  close: { id: 'close' },
});

export const UpsellPageHeader: FC<{
  pageTemplate: PageTemplate;
  onClose: () => void;
}> = ({ pageTemplate, onClose }) => {
  const intl = useIntl();

  return (
    <S.HeaderContainer $src={pageTemplate.headerImageUrl}>
      <S.Actions>
        <S.MemriseLogo
          buttonType="tertiary"
          a11yText={intl.formatMessage(msgs.memrise)}
          icon="memrise"
          href="/"
        />
        <S.CloseButton
          buttonType="tertiary"
          a11yText={intl.formatMessage(msgs.close)}
          icon="closedFilled"
          onClick={onClose}
        />
      </S.Actions>
      <S.HeaderContent>
        <S.Title>{intl.formatMessage({ id: pageTemplate.titleMessageId })}</S.Title>
        <S.SubTitle>{intl.formatMessage({ id: pageTemplate.subtitleMessageId })}</S.SubTitle>
      </S.HeaderContent>
    </S.HeaderContainer>
  );
};

export default UpsellPageHeader;
